<template>
  <div class="cont">

  </div>
</template>

<script>
  export default {
    data() {
      return {
        code: "",
        path: ''
      }
    },
    computed: {},
    created() {
      this.code = this.$route.query.code
      this.path = this.$route.query.path

      if (this.code) {
        this.weixinLogin()
      }else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    methods: {
      // 微信登录
      weixinLogin() {
        this.$api.apiContent.loginAutoByCookie({
          emofUserTokenSafer: this.code
        }).then(res => {
          this.$store.state.userMid = res.data.mid
          this.$store.state.userName = res.data.mnickname
          this.$store.state.userMthumb = res.data.mthumb
          this.$store.state.userRoleid = res.data.roleid
          this.$store.state.allToken = res.data.emofUserTokenSafer
            let that = this
            setTimeout(function () {
                that.$router.push('/home')
            },1500)
        }).catch(e => {
          this.$message.error(e.msg)
          let that = this
          setTimeout(function () {
            that.$router.push('/login')
          },1500)
        })
      },
    },
    components: {},
    watch: {}
  }
</script>

<style scoped lang="scss">
  .cont{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #fff;
  }
</style>
